import { render, staticRenderFns } from "./EmphasisClarification.vue?vue&type=template&id=38c505f2"
import script from "./EmphasisClarification.vue?vue&type=script&lang=js"
export * from "./EmphasisClarification.vue?vue&type=script&lang=js"
import style0 from "./EmphasisClarification.vue?vue&type=style&index=0&id=38c505f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports